module.exports = __webpack_public_path__ + "media/images/new_home/trash_black-a183620a8840391e27988f58318b1172.png";